import {BitrixVue} from 'ui.vue3';
import { mapState } from 'ui.vue3.pinia';
import { vplSiteStore } from 'vpl.tas';
import { ItemEditBtns } from 'vpl.tas';
import { holdCatalogPreloader, releaseCatalogPreloader } from 'vpl.tas';


export const BrandProjects = {
    components: {
        ItemEditBtns
    },
    props: {
        structKey: [String, Number],
        brandName: [String, Number]
    },
    methods: {
        lazyLoad(link){
            link = link.split('#')[0];
            let arRoute = link.split('?');
            let params = 'get_json=Y';
            if(arRoute[1]){
                params += '&' + arRoute[1];
            }

            holdCatalogPreloader();
            $.ajax({
                url: arRoute[0] + '?' + params,
                method: 'GET',
                complete: () => releaseCatalogPreloader(),
                success: (response) => {
                    response = JSON.parse(response);

                    this.getProjects.ITEMS = [...this.items, ...response.struct[this.structKey].CHILDS[this.childKey].componentData.ITEMS];

                    this.getProjects.PAGIN = response.struct[this.structKey].CHILDS[this.childKey].componentData.PAGIN;

                }
            });

        },
        hoverVideo(event, type) {
            if(type == 'video')
                $(event.target).find('video').get(0).play();
        },
        hideVideo(event, type) {
            if(type == 'video')
                $(event.target).find('video').get(0).pause();
        }
    },
    updated(){
        this.items = this.getProjects.ITEMS;
        this.pagin = this.getProjects.PAGIN;
    },
    mounted(){
        this.items = this.getProjects.ITEMS;
        this.pagin = this.getProjects.PAGIN;
    },
    computed: {
        ...mapState(vplSiteStore, ['struct', 'SITE_TEMPLATE_PATH']),
        childKey(){
            for(let i in this.struct[this.structKey].CHILDS){
                if(this.struct[this.structKey].CHILDS[i].componentData.VUE_COMPONENT == 'BrandProjects'){
                    return i;
                }
            }
        },
        getProjects(){
            return this.struct[this.structKey].CHILDS[this.childKey].componentData;
        }
    },
    template: `
        <section v-if="this.getProjects.ITEMS.length" class="section section--gray">
            <div class="container">
                <div class="section__heading">
                    <div class="section__title-wp">
                        <h2 class="section__title">
                            Реализованные нами проекты <br>
                            с брендом {{this.brandName}}
                        </h2>
                    </div>
                <a href="/vypolnennye-proekty/" class="btn btn--border projects__all-link">Все проекты</a>
        </div>
                <div class="brand__projects">
                    <div class="brand__projects-list is-show">

                        <a  v-for="item in this.getProjects.ITEMS"
                            :href="item.LINK"
                            class="projects__item js-project-item"
                            @mouseover="hoverVideo($event, item.CARD_TYPE)"
                            @mouseleave="hideVideo($event, item.CARD_TYPE)"
                            :key="item.ID">
                            <div class="projects__item-img">
                                <img v-if="item.CARD_TYPE == 'photo'" class="lazy" loading="lazy" src="data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='1' height='1'/%3E" :data-src="item.PREVIEW" :alt="item.NAME" :title="item.NAME">
                                <video v-if="item.CARD_TYPE == 'video'" preload="metadata" playsinline="" webkit-playsinline="" loop="" muted="">
                                    <source :src="item.PREVIEW" :type="item.FILE_TYPE">
                                </video>
                            </div>
                            <div class="projects__item-top">
                                <div v-if="item.TYPE" class="projects__item-tag">
                                    {{item.TYPE}}
                                </div>
                                <div class="projects__item-title">
                                    {{item.NAME}}
                                    <svg class="icon icon-arrow-next"><use xlink:href="#icon-arrow-next"></use></svg>
                                </div>
                                <div class="projects__item-date">
                                    {{item.YEAR}}
                                </div>
                            </div>
                            <div v-if="item.CARD_TYPE == 'photo'" class="projects__item-icon">
                                <svg class="ico ico-foto" width="13" height="13" aria-hidden="true"><use xlink:href="#ico-foto"></use></svg>
                                {{item.GALLERY_COUNT}}
                            </div>
                            <div v-if="item.CARD_TYPE == 'video'" class="projects__item-icon">
                                <svg class="ico ico-play" width="17" height="18" aria-hidden="true"><use xlink:href="#ico-play"></use></svg>
                            </div>
                        </a>
                    </div>
                    <template v-for="link in this.getProjects.PAGIN">
                        <a v-if="link.type==='showmore'" href="#" @click.prevent="lazyLoad(link.link)" class="btn btn--border is-active">Показать ещё</a>
                    </template>
                </div>
            </div>
        </section>
    `
}